var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home safe-area-inset-bottom" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/AD_page_01.jpg"), alt: "" }
      }),
      _c("div", { attrs: { id: "willingTest" } }),
      _c("img", {
        attrs: { src: require("@/assets/images/AD_page_02.jpg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }